import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Web3Provider } from "@ethersproject/providers";
import { createWeb3ReactRoot, Web3ReactProvider } from "@web3-react/core";
// import { NetworkContextName } from "./src/constants";
import { SettingsProvider } from "src/context/SettingsContext";
// const Web3ProviderNetwork = createWeb3ReactRoot(NetworkContextName);

// localStorage is shared across tabs; auth lives in sessionStorage so admin and clinic sessions stay isolated per tab.
(function migrateLegacyAuthToSessionStorage() {
  try {
    if (typeof window === "undefined") return;
    if (!window.sessionStorage.getItem("adminToken") && window.localStorage.getItem("adminToken")) {
      window.sessionStorage.setItem("adminToken", window.localStorage.getItem("adminToken"));
      const userType = window.localStorage.getItem("userType");
      if (userType) window.sessionStorage.setItem("userType", userType);
      const legacySession = window.localStorage.getItem("creatturAccessToken");
      if (legacySession) window.sessionStorage.setItem("creatturAccessToken", legacySession);
      window.localStorage.removeItem("adminToken");
      window.localStorage.removeItem("userType");
      window.localStorage.removeItem("creatturAccessToken");
    }
  } catch (e) {
    // storage unavailable (private mode, quota)
  }
})();

function getLibrary(provider) {
  const library = new Web3Provider(provider);
  library.pollingInterval = 15000;
  return library;
}

ReactDOM.render(
  <Web3ReactProvider getLibrary={getLibrary}>
    {/* <Web3ProviderNetwork getLibrary={getLibrary}> */}
      <SettingsProvider>
        <App />
      </SettingsProvider>
    {/* </Web3ProviderNetwork>   */}
  </Web3ReactProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
